export default "__VITE_ASSET__C81nV2AK__"